import React from "react";
import { useFormik } from "formik";
import oportunityService from "@services/Oportunity/OportunityService";
import { OportunityContext } from "@context/oportunityContex";
import AccordionCreditRatingComponent from "../../components/AccordionCreditRatingComponent";
import Spinner from "@components/common/Spinner";
import Button from "@components/common/Button";
import type { IValidationCreditRatingSchema } from "src/@types/Oportunity";
import enterprisesServiceInstance from "@services/Enterprises/enterprisesService";
import Alert from "@components/common/Alert";
import { LoginContext } from "@context/loginContext";
import { RxUpdate } from "react-icons/rx";
import { optionBankCreditRating } from "@helpers/optionSelect";
import { useMessageErrorToast } from "@hook/useMessageErrorToast";
import { useMessageToast } from "@hook/useMessageToast";
import type { IViewCreditRatingComponent } from "src/@types/Sales";
import Modal from "@components/Sales/Modal";
import UpdateDataClientComponent from "../../components/UpdateDataClientComponent";
import { Box, Flex, Stack, Text, Heading } from "@chakra-ui/react";
import { theme } from "src/styles/theme";

type ValueFormik = {
  observations: string;
};

const ViewCreditRatingComponent = ({ hash }: IViewCreditRatingComponent) => {
  const displayMessage = useMessageToast();
  const displayMessageError = useMessageErrorToast();

  const regionalUser: any = localStorage.getItem("@regional");
  const regiaolUser: any = localStorage.getItem("@regiao");
  const unityUser: any = localStorage.getItem("@empresa");
  const codEmpreendimentoUAU: any = localStorage.getItem(
    "@codEmpreendimentoUAU"
  );
  const { signOut } = React.useContext(LoginContext);
  const {
    nameCreditRating,
    nomeConta,
    accessCreditRating,
    setAccessCreditRating,
    statusCreditRating,
    accessCreateOp,
    cnpjCorresponding,
    setCnpjCorresponding,
    allowSendToAnalisys,
    setSuccessUpdateAddresModal,
    setIsUpdateAdress,
    setIsUpdateAdressIncome,
    regionalOp,
  } = React.useContext(OportunityContext);
  const [bank, setBank] = React.useState("");
  const [estimatedPurchaseValue, setEstimatedPurchaseValue] =
    React.useState("");
  const [futureSale, setFutureSale] = React.useState("");

  const [nomeEmpreendimento, setNomeEmpreendimento] = React.useState("");
  const [idEnterprises, setIdEnterprises] = React.useState("");
  const [enterprises, setEnterprises] = React.useState("");
  const [selectEnterprises, setSelectEnterprises] = React.useState("");

  const [acActivity, setAcActivity] = React.useState("");
  const [dataCreditRating, setDataCreditRating] = React.useState<any>([]);

  const [editAccordion, setEditAccordion] = React.useState(false);

  const [isUnauthorized, setIsUnauthorized] = React.useState(false);
  const [loadingCreditRating, setLoadingCreditRating] = React.useState(false);
  const [loadingEnterprise, setLoadingEnterprise] = React.useState(false);
  const [dataEnterprises, setDataEnterprises] = React.useState([]);
  const [dataGetCreditRating, setDataGetCreditRating] = React.useState([]);

  const [dataCorresponding, setDataCorresponding] = React.useState([]);
  const [corresponding, setCorresponding] = React.useState("");
  const [selectCorresponding, setSelectCorresponding] = React.useState("");
  const [correspondingId, setCorrespondingId] = React.useState("");
  const [loadingCorresponding, setLoadingCorresponding] = React.useState(false);

  const [loadingUpdate, setLoadingUpdate] = React.useState(false);
  const [successEditCreditRating, setSuccessEditCreditRating] =
    React.useState(false);
  const [showModalUpdateDate, setShowModalUpdateDate] = React.useState(false);
  const [showModalUpdateAdress, setShowModalUpdateAdress] =
    React.useState(false);
  const [oportunity, setOportunity] = React.useState<any>();

  const [dataReasonsDisapproval, setDataReasonsDisapproval] = React.useState<
    any[]
  >([]);
  const [isCorresponding, setIsCorresponding] = React.useState(false);
  const [completeFunction, setCompleteFunction] = React.useState(false);

  const [relationship, setRelationship] = React.useState<any[]>([]);
  const [currentIndex, setCurrentIndex] = React.useState<number>(0);

  const initialValues = {
    account: nomeConta,
    realState: dataCreditRating?.imobiliaria,
    oportunity: dataCreditRating?.opportunityIdSalesforce,
    observations: dataCreditRating?.observacoes,
    status: dataCreditRating?.status,
    statusBankRating: dataCreditRating?.statusAnaliseBanco,
    pendingSAFI: dataCreditRating?.motivoPendenciaSafi,
    bankRate: dataCreditRating?.taxaBanco,
    justification: dataCreditRating?.justificativa,
    amortizationTable: dataCreditRating?.tabelaDeAmortizacao,
    modality: dataCreditRating?.modalidade,
    Sicaq: dataCreditRating?.sicaq,
    appraisalValue: dataCreditRating?.valorDeAvaliacao,
    olderAge: dataCreditRating?.idadeMaisVelho,
    financingValue: dataCreditRating?.valorDoFinanciamento,
    calculatedIncome: dataCreditRating?.rendaApurada,
    subsidyAmount: dataCreditRating?.valorDeSubsidio,
    hasDependents: dataCreditRating?.possuiDependentes,
    fgtsCalculated: dataCreditRating?.fgtsApurado,
    typeIncome: dataCreditRating?.tipoDeRenda,
    approvedInstallmentValue: dataCreditRating?.valorParcelaAprovada,
    financingTerm: dataCreditRating?.prazoFinanciamento,
    firstInstallmentFinanced: dataCreditRating?.primeiraParcelaFinanciamento,
    fid: dataCreditRating?.fid,
    integrationStatus: dataCreditRating?.statusDaIntegracao,
    type: dataCreditRating?.tipo,
    dateFirstSentAnalysis: dataCreditRating?.dataPrimeiroEnvioAnalise,
    dateLastSentAnalysis: dataCreditRating?.dataUltimoEnvioAnalise,
    safiApprovalDate: dataCreditRating?.dataAprovacaoSafi,
  };

  const formik: any = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: async (values: any) => handleUpdateCreditRating(values),
  });

  const handleGetEnterprises = async () => {
    setLoadingEnterprise(true);

    try {
      const response = await enterprisesServiceInstance.getEnterprises({
        regional: regionalOp,
      });

      if (response.status >= 400 && response?.status !== 401) {
        setLoadingEnterprise(false);
        setDataEnterprises([]);
        console.log("status 400", response);
        return;
      }
      if (response.status === 401) {
        setLoadingEnterprise(false);
        setIsUnauthorized(true);
        setDataEnterprises([]);
        return;
      }

      const dataArray: any = Object.values(response);

      setDataEnterprises(dataArray);
      setLoadingEnterprise(false);
    } catch (error) {
      setLoadingEnterprise(false);
      console.log("errorHandleGetEnterprises", error);
    }
  };

  const handleGetCorresponding = async () => {
    setLoadingCorresponding(true);

    try {
      const response = await oportunityService.getCorresponding({
        oportunidadeIdSalesforce: accessCreateOp.oportunityIdSalesforce,
      });

      if (response.status >= 400 && response?.status !== 401) {
        setLoadingCorresponding(false);
        setDataCorresponding([]);
        console.log("status 400", response);
        return;
      }
      if (response.status === 401) {
        setLoadingCorresponding(false);
        setIsUnauthorized(true);
        setDataCorresponding([]);
        return;
      }

      const dataArray: any = Object.values(response);

      setDataCorresponding(dataArray);
      setLoadingCorresponding(false);
    } catch (error) {
      setLoadingCorresponding(false);
      console.log("errorHandleGetCorresponding", error);
    }
  };

  const handleUpdateCreditRating = async (value: ValueFormik) => {
    setLoadingUpdate(true);

    try {
      const response = await oportunityService.updateCreditRating({
        idAvaliacaoCreditoSalesforce:
          accessCreditRating.idAvaliacaoCreditoSalesforce,
        idEmpreendimentoSales: idEnterprises,
        acAtiva: acActivity === "Sim" ? true : false,
        banco: bank,
        valorEstimadoCompraEVenda: estimatedPurchaseValue,
        observacoes: value.observations,
        nomeCorrespondente: corresponding || null,
        CNPJCorrespondente: cnpjCorresponding || null,
      });

      if (response.status >= 400 && response?.status !== 401) {
        setLoadingUpdate(false);
        displayMessageError({
          message: "Erro ao atualizar avaliação de crédito!",
        });
        console.log("status 400", response);
        return;
      }
      if (response.status === 401) {
        setLoadingUpdate(false);
        setIsUnauthorized(true);
        return;
      }

      setLoadingUpdate(false);
      setEditAccordion(false);
      setSuccessEditCreditRating(true);

      displayMessage({
        title: "Atividade editada com sucesso!",
        message:
          "Suas alterações foram salvas e você já pode continuar sua venda.",
        titleButton: "ACESSAR AVALIAÇÃO DE CRÉDITO",
        onClick: () => setSuccessEditCreditRating(false),
      });
    } catch (error) {
      setLoadingUpdate(false);
      console.log("errorHandleUpdateCreditRating", error);
    }
  };

  const handleSendToSAFI = async () => {
    setLoadingUpdate(true);

    const creditRating = await oportunityService.getCreditRatingById({
      IdAvaliacaoCreditoSalesforce:
        accessCreditRating.idAvaliacaoCreditoSalesforce,
    });
    const fid = creditRating.fid ?? 0;

    const codigoBanco =
      bank === "Avaliação Interna"
        ? null
        : (optionBankCreditRating.find((o) => o.name === bank)?.code ?? 0);

    const safiResponse = await oportunityService.sendToSAFI({
      codigoBanco: codigoBanco,
      fid: fid,
      idAvaliacaoCreditoSalesforce:
        accessCreditRating.idAvaliacaoCreditoSalesforce,
      idEmpreendimentoSales: idEnterprises,
      opportunityIdSalesforce: oportunity?.opportunityIdSalesforce,
      imobiliaria: oportunity?.imobiliaria,
      valorEstimadoCompraEVenda: formatNumber(estimatedPurchaseValue),
      observacao: creditRating?.observacoes ?? "",
      status: creditRating?.status ?? "Rascunho",
      CNPJCorrespondente: cnpjCorresponding || null,
    });

    if (safiResponse.tipoRetorno !== 0) {
      setLoadingUpdate(false);
      displayMessageError({
        message:
          "Favor preencher os dados necessários para avaliação financeira.",
      });
      return;
    }

    displayMessage({
      title: "Avaliação enviada!",
      message:
        "A análise de crédito foi enviada para o SAFI e você já pode continuar sua venda.",
      titleButton: "CONTINUAR",
      onClick: () => {},
    });

    setIsUpdateAdressIncome(false);
    setIsUpdateAdress(false);

    setLoadingUpdate(false);
    setSuccessUpdateAddresModal(false);
    setShowModalUpdateAdress(false);
    setShowModalUpdateDate(false);
    setAccessCreditRating({ ...accessCreditRating });
    setCurrentIndex(0);
  };

  const titleHeaderTable = [
    { id: "#", name: "#" },
    { id: "Critério:", name: "Critério:" },
  ];

  const handleAdjustWidth = (id: string) => {
    if (id === "#") return "6%";

    return undefined;
  };

  React.useEffect(() => {
    if (nomeEmpreendimento !== "") {
      setSelectEnterprises(nomeEmpreendimento);
      setEnterprises(nomeEmpreendimento);
    }
  }, [nomeEmpreendimento]);

  React.useEffect(() => {
    const handleGetCreditRatingById = async () => {
      setCompleteFunction(false);
      setLoadingCreditRating(true);
      try {
        const response = await oportunityService.getCreditRatingById({
          IdAvaliacaoCreditoSalesforce:
            accessCreditRating.idAvaliacaoCreditoSalesforce,
        });

        if (response.status === 401) {
          setLoadingCreditRating(false);
          setDataCreditRating([]);
          return;
        }

        if (response.status >= 400 && response?.status !== 401) {
          setLoadingCreditRating(false);
          setDataCreditRating([]);
          console.log("status 400", response);
          return;
        }
        if (response.status === 401) {
          setLoadingCreditRating(false);
          setIsUnauthorized(true);
          return;
        }

        const newValorEstimadoCompraEVenda =
          response?.valorEstimadoCompraEVenda;

        const formatMoney = (valor: number) => {
          const newValue = new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(valor);
          return newValue;
        };

        setCompleteFunction(true);

        setDataReasonsDisapproval(
          Array.isArray(response?.motivosReprovacao)
            ? response?.motivosReprovacao
            : []
        );

        setCnpjCorresponding(response?.cnpjCorrespondente);
        setCorresponding(
          response?.nomeCorrespondente ? response?.nomeCorrespondente : ""
        );
        setSelectCorresponding(
          response?.nomeCorrespondente ? response?.nomeCorrespondente : ""
        );
        setIdEnterprises(response?.idEmpreendimentoSales);
        setNomeEmpreendimento(response.nomeEmpreendimento);

        setDataGetCreditRating(response);
        setEstimatedPurchaseValue(
          formatMoney(newValorEstimadoCompraEVenda?.toString())
        );
        setBank(response?.banco);
        setFutureSale(response?.vendaFutura ? "Sim" : "Não");
        setAcActivity(response?.acAtiva ? "Sim" : "Não");

        const newResp: IValidationCreditRatingSchema = response;
        setDataCreditRating(newResp);
        // setLoadingCreditRating(false);
      } catch (error) {
        setLoadingCreditRating(false);
        console.log("ErrorHandleGetCreditRatingById", error);
      }
    };

    if (hash === "ViewCreditRatingComponent") {
      handleGetCreditRatingById();
    }
  }, [hash, accessCreditRating, successEditCreditRating, setCnpjCorresponding]);

  React.useEffect(() => {
    const handleGetOportunity = async () => {
      const oportunity = await oportunityService.getOportunityById({
        OportunidadeId: accessCreateOp.oportunidadeId,
      });
      setOportunity(oportunity);
    };

    handleGetOportunity();
  }, [accessCreateOp.oportunidadeId]);

  React.useEffect(() => {
    const handleGetCorrespondingRow = async () => {
      setLoadingCreditRating(true);

      try {
        const response = await oportunityService.getCorrespondingRow({
          idEmpreendimento: idEnterprises,
          regional: regionalUser,
          unidadeDeNegocio: unityUser,
          regiao:
            regiaolUser === "null" || regiaolUser === "undefined"
              ? null
              : regiaolUser,
        });

        if (response.status >= 400 && response?.status !== 401) {
          setLoadingCreditRating(false);
          console.log("status 400", response);
          return;
        }
        if (response.status === 401) {
          setLoadingCreditRating(false);
          setIsUnauthorized(true);
          return;
        }

        setIsCorresponding(response);
        setLoadingCreditRating(false);
      } catch (error) {
        setLoadingCreditRating(false);
        console.log("errorHandleGetCorrespondingRow", error);
      }
    };

    if (completeFunction) {
      handleGetCorrespondingRow();
    }
  }, [idEnterprises, regiaolUser, regionalUser, unityUser, completeFunction]);

  return (
    <>
      <Alert
        onOpen={isUnauthorized}
        title="Erro ao carregar os dados!"
        titleButton={"Logar novamente"}
        description={
          "Sua sessão expirou, faça login novamente para ter acesso."
        }
        onClick={() => {
          signOut();
        }}
      />

      <Modal
        onOpen={showModalUpdateDate}
        title={
          currentIndex === 0
            ? "Atualizar dados do comprador principal"
            : "Atualizar dados do compositor de renda"
        }
        subtitle="Verifique se os dados estão corretos e atualizados para enviar a análise de crédito"
        onClose={() => setShowModalUpdateDate(false)}
        relationship={relationship}
        currentIndexClient={currentIndex}
      >
        <UpdateDataClientComponent
          onBack={() => setShowModalUpdateDate(false)}
          onSuccess={handleSendToSAFI}
          isRequired="AC"
          loadindSuccess={loadingUpdate}
          relationship={relationship}
          setRelationship={setRelationship}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
        />
      </Modal>

      <Flex direction="column" w="100%" p="8px">
        {/* Header Section */}
        <Flex
          flexDir={{ base: "column", sm: "column", md: "row" }}
          justifyContent="space-between"
          alignItems="center"
          mb={4}
          pl={"4px"}
        >
          <Heading size="lg" color={theme.text} fontWeight={"medium"}>
            {nameCreditRating || accessCreditRating.nome}
          </Heading>

          <Flex gap={4} justifyContent={{base: "flex-start", sm: "flex-start", md: "flex-end"}}>
            <Box w={"100px"}>
              <Button
                title={
                  <RxUpdate
                    style={{ fontSize: "20px", width: "fit-content" }}
                  />
                }
                onClick={() => setAccessCreditRating({ ...accessCreditRating })}
              />
            </Box>

            <Box w={"230px"}>
              <Button
                title={
                  loadingUpdate ? (
                    <Flex justify={"center"} align={"center"}>
                      <Spinner />
                    </Flex>
                  ) : (
                    "ENVIAR ANALISE FINANCEIRA"
                  )
                }
                onClick={async () => {
                  setLoadingUpdate(true);
                  const sentDocuments = await oportunityService.checkDocuments(
                    accessCreateOp.oportunityIdSalesforce
                  );

                  if (sentDocuments?.status === 400) {
                    setLoadingUpdate(false);
                    displayMessageError({
                      message: sentDocuments?.data
                        ? sentDocuments?.data
                        : "Cliente ainda não enviou documentos obrigatórios.",
                      whiteSpace: "pre-wrap",
                    });
                    return;
                  } else {
                    setLoadingUpdate(false);
                    setShowModalUpdateDate(true);
                  }
                }}
                disabled={loadingUpdate || editAccordion}
              />
            </Box>
          </Flex>
        </Flex>

        {/* Credit Rating Accordion Section */}
        <Box
          bg="white"
          borderRadius="8px"
          mb={4}
          boxShadow="sm"
          overflow="hidden"
          p={"4px"}
        >
          <AccordionCreditRatingComponent
            loading={loadingCreditRating}
            isCorresponding={isCorresponding}
            status={statusCreditRating}
            formik={formik}
            dataGetCreditRating={dataGetCreditRating}
            edit={editAccordion}
            setEdit={setEditAccordion}
            getEnterprises={handleGetEnterprises}
            dataEnterprises={dataEnterprises}
            setIdEnterprise={setIdEnterprises}
            bank={bank}
            setBank={setBank}
            estimatedPurchaseValue={estimatedPurchaseValue}
            setEstimatedPurchaseValue={setEstimatedPurchaseValue}
            futureSale={futureSale}
            setFutureSale={setFutureSale}
            enterprises={enterprises}
            setEnterprises={setEnterprises}
            selectEnterprises={selectEnterprises}
            setSelectEnterprises={setSelectEnterprises}
            loadingEnterprise={loadingEnterprise}
            acActivity={acActivity}
            setAcActivity={setAcActivity}
            loadingUpdate={loadingUpdate}
            handleUpdateCreditRating={formik.handleSubmit}
            handleSendToSAFI={handleSendToSAFI}
            dataCorresponding={dataCorresponding}
            corresponding={corresponding}
            setCorresponding={setCorresponding}
            selectCorresponding={selectCorresponding}
            setSelectCorresponding={setSelectCorresponding}
            setCorrespondingId={setCorrespondingId}
            setCnpjCorresponding={setCnpjCorresponding}
            handleGetCorresponding={handleGetCorresponding}
            loadingCorresponding={loadingCorresponding}
          />
        </Box>

        {/* Disapproval Reasons Section */}
        <Box bg="white" borderRadius="8px" boxShadow="sm" overflow="hidden">
          <Box p={3} color={theme.text} fontWeight="bold">
            <Text>Motivos da Reprovação</Text>
          </Box>

          <Box p={4}>
            <Stack spacing={4}>
              <Flex>
                {titleHeaderTable.map(({ id, name }) => (
                  <Box key={id} flex={id === "#" ? "0 0 6%" : "1"}>
                    <Text fontSize="xs" color={theme.text}>
                      {name}
                    </Text>
                  </Box>
                ))}
              </Flex>

              {dataReasonsDisapproval?.length === 0 ? (
                <Box p={3} bg={theme.backgroundGray} borderRadius="8px">
                  <Text fontSize="sm" fontWeight="bold">
                    Nenhum motivo foi encontrado.
                  </Text>
                </Box>
              ) : (
                <Stack spacing={2}>
                  {dataReasonsDisapproval?.map((message, index) => (
                    <Flex key={index} gap={2} alignItems="center">
                      <Flex w="6%" alignItems="center">
                        <Flex
                          w="40px"
                          h="40px"
                          borderRadius="8px"
                          bg={theme.error}
                          color="white"
                          alignItems="center"
                          justifyContent="center"
                          textAlign="center"
                        >
                          <Text fontSize="md" fontWeight="bold">
                            {index + 1 <= 9 ? `0${index + 1}` : index + 1}
                          </Text>
                        </Flex>
                      </Flex>

                      <Flex flex="1" alignItems="center">
                        <Text fontSize="sm" fontWeight="bold">
                          {message}
                        </Text>
                      </Flex>
                    </Flex>
                  ))}
                </Stack>
              )}
            </Stack>
          </Box>
        </Box>
      </Flex>
    </>
  );
};

export default React.memo(ViewCreditRatingComponent);

const formatNumber = (value: string) => {
  const number = value.replace(/\D/g, "");
  return Number(number) / 100;
};
